module.exports = __webpack_public_path__ + "static/img/flag4.7bc28e11.svg";